import './ServiciosTecnicos.css';
import React from "react";
import ServiciosTecnicos1 from '../../assets/About/ServiciosTecnicos/ServiciosTecnicos.png';

function ServiciosTecnicos() {
    return (
        <>
            <div className='servicios-tecnicos-container'>
                <p>
                    SILANDE es pionera en la I+D de selladores. Con tecnología líder, solidez técnica, estilo de trabajo riguroso y actitud científica firme, nuestra empresa disfruta de la reputación de "Calidad superior" en la industria. Hemos logrado logros gloriosos. Sin embargo, nuestra misión eterna es continuar con ello.
                </p>
                <p>
                    Con más de 40 tipos de productos, SILANDE puede satisfacer las necesidades de diferentes clientes. En el futuro, SILANDE seguirá ampliando más campos de aplicación de productos y comunicándose activamente con selladores extranjeros.
                </p>
                <img src={ServiciosTecnicos1} alt="Servicios Tecnicos" className="servicios-tecnicos-img" />
            </div>
        </>
    );
}

export default ServiciosTecnicos;
